/* esm.sh - applesauce-core@5.2.0/operations/tag/common */
export * from "/*applesauce-core@5.2.0/esnext/operations/tag/common.mjs";
